import api from './api';
import { getDeviceInfo } from '../utils/deviceUtils';

export const enrollMfa = async (token) => {
  const response = await api.post('/mfa/enroll', {}, {
    headers: { Authorization: token },
  });
  return response.data;
};

export const confirmMfaEnrollment = async (token, code) => {
  const response = await api.post('/mfa/enroll/confirm',
    { code, ...getDeviceInfo() },
    { headers: { Authorization: token } },
  );
  return response.data;
};

export const verifyMfaCode = async (token, code) => {
  const response = await api.post('/mfa/verify',
    { code, ...getDeviceInfo() },
    { headers: { Authorization: token } },
  );
  return response.data;
};
